import { render } from "./PersonalTutorView.vue?vue&type=template&id=0eb85a9d"
import script from "./PersonalTutorView.vue?vue&type=script&lang=js"
export * from "./PersonalTutorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__